var map = {
	"./404.svg": "./src/assets/icons/svg/404.svg",
	"./app.svg": "./src/assets/icons/svg/app.svg",
	"./arrow-down.svg": "./src/assets/icons/svg/arrow-down.svg",
	"./arrow-up.svg": "./src/assets/icons/svg/arrow-up.svg",
	"./bug.svg": "./src/assets/icons/svg/bug.svg",
	"./build.svg": "./src/assets/icons/svg/build.svg",
	"./cascader.svg": "./src/assets/icons/svg/cascader.svg",
	"./chart.svg": "./src/assets/icons/svg/chart.svg",
	"./checkbox.svg": "./src/assets/icons/svg/checkbox.svg",
	"./clipboard.svg": "./src/assets/icons/svg/clipboard.svg",
	"./code.svg": "./src/assets/icons/svg/code.svg",
	"./color.svg": "./src/assets/icons/svg/color.svg",
	"./component.svg": "./src/assets/icons/svg/component.svg",
	"./dashboard.svg": "./src/assets/icons/svg/dashboard.svg",
	"./date-range.svg": "./src/assets/icons/svg/date-range.svg",
	"./date.svg": "./src/assets/icons/svg/date.svg",
	"./delete.svg": "./src/assets/icons/svg/delete.svg",
	"./device.svg": "./src/assets/icons/svg/device.svg",
	"./device1.svg": "./src/assets/icons/svg/device1.svg",
	"./dict.svg": "./src/assets/icons/svg/dict.svg",
	"./documentation.svg": "./src/assets/icons/svg/documentation.svg",
	"./down.svg": "./src/assets/icons/svg/down.svg",
	"./download.svg": "./src/assets/icons/svg/download.svg",
	"./drag.svg": "./src/assets/icons/svg/drag.svg",
	"./druid.svg": "./src/assets/icons/svg/druid.svg",
	"./edit.svg": "./src/assets/icons/svg/edit.svg",
	"./education.svg": "./src/assets/icons/svg/education.svg",
	"./email.svg": "./src/assets/icons/svg/email.svg",
	"./example.svg": "./src/assets/icons/svg/example.svg",
	"./excel.svg": "./src/assets/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/assets/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/assets/icons/svg/eye-open.svg",
	"./eye.svg": "./src/assets/icons/svg/eye.svg",
	"./form.svg": "./src/assets/icons/svg/form.svg",
	"./fullscreen.svg": "./src/assets/icons/svg/fullscreen.svg",
	"./github.svg": "./src/assets/icons/svg/github.svg",
	"./guide.svg": "./src/assets/icons/svg/guide.svg",
	"./icon.svg": "./src/assets/icons/svg/icon.svg",
	"./input.svg": "./src/assets/icons/svg/input.svg",
	"./international.svg": "./src/assets/icons/svg/international.svg",
	"./job.svg": "./src/assets/icons/svg/job.svg",
	"./language.svg": "./src/assets/icons/svg/language.svg",
	"./link.svg": "./src/assets/icons/svg/link.svg",
	"./list.svg": "./src/assets/icons/svg/list.svg",
	"./lock.svg": "./src/assets/icons/svg/lock.svg",
	"./log.svg": "./src/assets/icons/svg/log.svg",
	"./logininfor.svg": "./src/assets/icons/svg/logininfor.svg",
	"./material.svg": "./src/assets/icons/svg/material.svg",
	"./message.svg": "./src/assets/icons/svg/message.svg",
	"./money.svg": "./src/assets/icons/svg/money.svg",
	"./monitor.svg": "./src/assets/icons/svg/monitor.svg",
	"./nested.svg": "./src/assets/icons/svg/nested.svg",
	"./number.svg": "./src/assets/icons/svg/number.svg",
	"./online.svg": "./src/assets/icons/svg/online.svg",
	"./password.svg": "./src/assets/icons/svg/password.svg",
	"./pdf.svg": "./src/assets/icons/svg/pdf.svg",
	"./people.svg": "./src/assets/icons/svg/people.svg",
	"./peoples.svg": "./src/assets/icons/svg/peoples.svg",
	"./phone.svg": "./src/assets/icons/svg/phone.svg",
	"./plus.svg": "./src/assets/icons/svg/plus.svg",
	"./post.svg": "./src/assets/icons/svg/post.svg",
	"./program.svg": "./src/assets/icons/svg/program.svg",
	"./publish.svg": "./src/assets/icons/svg/publish.svg",
	"./qq.svg": "./src/assets/icons/svg/qq.svg",
	"./question.svg": "./src/assets/icons/svg/question.svg",
	"./radio.svg": "./src/assets/icons/svg/radio.svg",
	"./rate.svg": "./src/assets/icons/svg/rate.svg",
	"./row.svg": "./src/assets/icons/svg/row.svg",
	"./scheduling.svg": "./src/assets/icons/svg/scheduling.svg",
	"./search.svg": "./src/assets/icons/svg/search.svg",
	"./select.svg": "./src/assets/icons/svg/select.svg",
	"./server.svg": "./src/assets/icons/svg/server.svg",
	"./shopping.svg": "./src/assets/icons/svg/shopping.svg",
	"./size.svg": "./src/assets/icons/svg/size.svg",
	"./skill.svg": "./src/assets/icons/svg/skill.svg",
	"./slider.svg": "./src/assets/icons/svg/slider.svg",
	"./star.svg": "./src/assets/icons/svg/star.svg",
	"./storage.svg": "./src/assets/icons/svg/storage.svg",
	"./swagger.svg": "./src/assets/icons/svg/swagger.svg",
	"./switch.svg": "./src/assets/icons/svg/switch.svg",
	"./system.svg": "./src/assets/icons/svg/system.svg",
	"./tab.svg": "./src/assets/icons/svg/tab.svg",
	"./table.svg": "./src/assets/icons/svg/table.svg",
	"./template.svg": "./src/assets/icons/svg/template.svg",
	"./textarea.svg": "./src/assets/icons/svg/textarea.svg",
	"./theme.svg": "./src/assets/icons/svg/theme.svg",
	"./time-range.svg": "./src/assets/icons/svg/time-range.svg",
	"./time.svg": "./src/assets/icons/svg/time.svg",
	"./tool.svg": "./src/assets/icons/svg/tool.svg",
	"./tree-table.svg": "./src/assets/icons/svg/tree-table.svg",
	"./tree.svg": "./src/assets/icons/svg/tree.svg",
	"./up.svg": "./src/assets/icons/svg/up.svg",
	"./upload.svg": "./src/assets/icons/svg/upload.svg",
	"./user.svg": "./src/assets/icons/svg/user.svg",
	"./validCode.svg": "./src/assets/icons/svg/validCode.svg",
	"./wechat.svg": "./src/assets/icons/svg/wechat.svg",
	"./zip.svg": "./src/assets/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";